import checkIsMobile from "is-mobile";
import { ref } from "vue";

/**
 * This composable should be used for identifying mobile browsers.
 *
 * To identify if we are currently in a NativeApp Wrapper, use `useAppWrapper` composable.
 **/
export const useIsMobile = () => {
  const isMobile = ref(checkIsMobile());

  return {
    isMobile,
  };
};
